import { render, staticRenderFns } from "./TheProductSetDetails.vue?vue&type=template&id=32db988a&"
import script from "./TheProductSetDetails.vue?vue&type=script&lang=js&"
export * from "./TheProductSetDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32db988a')) {
      api.createRecord('32db988a', component.options)
    } else {
      api.reload('32db988a', component.options)
    }
    module.hot.accept("./TheProductSetDetails.vue?vue&type=template&id=32db988a&", function () {
      api.rerender('32db988a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/TheProductSetDetails.vue"
export default component.exports